/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReceiptRequest } from '../../models/receipt-request';

export interface ApiRequestReceiptInitialGet$Params {
}

export function apiRequestReceiptInitialGet(http: HttpClient, rootUrl: string, params?: ApiRequestReceiptInitialGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptRequest>> {
  const rb = new RequestBuilder(rootUrl, apiRequestReceiptInitialGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReceiptRequest>;
    })
  );
}

apiRequestReceiptInitialGet.PATH = '/api/Request/Receipt/Initial';
